import { createElementBlock as o, openBlock as t, createElementVNode as e } from "vue";
import r from "./index289.js";
const l = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n(s, a, m, p, f, i) {
  return t(), o("svg", c, a[0] || (a[0] = [
    e("path", {
      fill: "currentColor",
      d: "M20 20.75a.75.75 0 1 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 1 1 1.5 0A2.75 2.75 0 0 1 20 20.75Zm2-5.33a.75.75 0 0 1-.75-.75v-2a.75.75 0 1 1 1.5 0v2a.75.75 0 0 1-.75.75ZM4.564 5.97l2.333 2.333a.75.75 0 1 1-1.06 1.06L4.75 8.277V18.5c0 .414.336.75.75.75l10.022-.001-.886-.885a.75.75 0 0 1-.072-.977l.072-.084a.75.75 0 0 1 1.061 0l2.333 2.333a.75.75 0 0 1 0 1.061l-2.333 2.333a.75.75 0 0 1-1.06-1.06l1.218-1.22H14.67l-.015-.001-9.155.001a2.25 2.25 0 0 1-2.25-2.25V8.342L2.23 9.364a.75.75 0 0 1-.976.072l-.084-.072a.75.75 0 0 1 0-1.061L3.503 5.97a.75.75 0 0 1 1.06 0ZM4 4.75A.75.75 0 0 1 3.25 4 2.75 2.75 0 0 1 6 1.25a.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-.75.75Zm5.33-2a.75.75 0 0 1 0-1.5h2a.75.75 0 1 1 0 1.5h-2Zm12.5 2a.75.75 0 0 0 .75-.75 2.75 2.75 0 0 0-2.75-2.75.75.75 0 1 0 0 1.5c.69 0 1.25.56 1.25 1.25 0 .414.336.75.75.75Zm0 5.33a.75.75 0 0 0 .75-.75v-2a.75.75 0 1 0-1.5 0v2c0 .414.336.75.75.75ZM16.5 2.75a.75.75 0 1 0 0-1.5h-2a.75.75 0 1 0 0 1.5h2Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ r(l, [["render", n]]);
export {
  d as default
};
